import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

//获取短信验证码
export function codeData(data){
	return request.post(config.baseApi+"/supplier/suppliersend",data)
}

//账户注册
export function register(data){
	return request.post(config.baseApi+"/supplier/supplierregister",data)
}

//获取二维码
export function qrcodeData(data){
	return request.post(config.baseApi+"/wechat/wxcode",data)
}

//检测微信绑定
export function wxBind(data){
	return request.post(config.baseApi+"/wechat/iscodelogin",data)
}

//账号密码登录
export function accountLogin(data){
	return request.post(config.baseApi+"/supplier/supplierlogin",data)
}

//账号密码登录
export function codeLogin(data){
	return request.post(config.baseApi+"/supplier/suppliercodelogin",data)
}


//获取个人信息
export function userinfoData(data){
	return request.post(config.baseApi+"/supplier/supplieruserinfo",data)
}

//获取菜单权限
export function ucenterMenu(data){
	return request.post(config.baseApi+"/supplier/System.Supplierrole/getMenu",data)
}